export const CONTACT_A_TECHNICIAN_OPTION = "Contact a technician"
